import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { FormattedMessage } from 'react-intl'
import { Map } from 'immutable'
import cx from 'classnames'
import bowser from 'bowser'
import _ from 'lodash'

import { isSelectedByBlocks } from './helpers'

import Button from './components/Button'

import hocOnChange from '../HocOnChange'
import hocConnect from './hocConnect'

import './style.scss'

const browser = bowser.getParser(typeof window !== 'undefined' ? window.navigator.userAgent : 'UA')

@hocOnChange
@hocConnect
export default class DropDown extends Component {
    static propTypes = {
        activeBlocks: PropTypes.object,
        activeItem: PropTypes.func.isRequired,
        activeName: PropTypes.string,
        blocks: PropTypes.object,
        closeDropdownMenu: PropTypes.func.isRequired,
        configuration: IPropTypes.list.isRequired,
        moduleName: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func,
        open: PropTypes.bool.isRequired,
        toggleDropdownMenu: PropTypes.func.isRequired,
    }

    static defaultProps = {
        onChange: () => {},
    }

    onClickMenuButton = (buttonName, _e) => {
        const { activeItem, closeDropdownMenu, moduleName, name, onChange } = this.props

        _e.stopPropagation()

        activeItem(moduleName, name, buttonName)
        closeDropdownMenu(moduleName, name)
        onChange(moduleName, name, buttonName)
    }

    onClickHandler = () => {
        const { moduleName, name, toggleDropdownMenu, configuration } = this.props

        if (configuration.size <= 1) return null

        toggleDropdownMenu(moduleName, name)
        return null
    }

    onBlurHandler = () => {
        const { moduleName, name, closeDropdownMenu } = this.props

        // IE fire onBlur before click event and don't blur menu after click on menu button => focus to body element
        if (browser.is('Internet Explorer'))
            setTimeout(() => {
                closeDropdownMenu(moduleName, name)
                document.body.focus()
            }, 200)
        else closeDropdownMenu(moduleName, name)
    }

    renderMenu = () => {
        const { configuration, activeName, moduleName, name, activeBlocks, blocks } = this.props

        const menuButtons = configuration.map((button) => {
            const textId = `scenes.Gnosus.components.Ribbon.components.DropDown.${moduleName}.${name}.${button.get(
                'name'
            )}`
            const text = <FormattedMessage id={textId} />
            const buttonName = button.get('name')

            let selected = false
            if (!_.isNil(blocks)) {
                const itemBlocks = blocks.get(buttonName).get('blocks').toJS()

                selected = isSelectedByBlocks(activeBlocks.toJS(), itemBlocks)
            }

            return (
                <Button
                    key={button.get('name')}
                    name={button.get('name')}
                    text={text}
                    disabled={button.get('disabled')}
                    onClickHandler={this.onClickMenuButton}
                    selected={activeName === buttonName && selected}
                />
            )
        })

        return (
            <div className={'menu'}>
                <div className={'menu-wrap'}>{menuButtons}</div>
            </div>
        )
    }

    render() {
        const { activeName, moduleName, configuration, name, open, activeBlocks, blocks } = this.props

        const mainButtonTextId = `scenes.Gnosus.components.Ribbon.components.DropDown.${moduleName}.${name}.${activeName}`
        const mainButtonText = <FormattedMessage id={mainButtonTextId} />

        let selected = false
        if (!_.isNil(blocks)) {
            const activeItemBlocks = blocks.get(activeName, Map()).get('blocks', Map()).toJS()

            selected = isSelectedByBlocks(activeBlocks.toJS(), activeItemBlocks)
        }

        return (
            <div
                className={cx('drop-down-ribbon', !open && 'hide')}
                onBlur={this.onBlurHandler}
                onClick={this.onClickHandler}
                tabIndex={-1}
            >
                <div className={'main'}>
                    <Button
                        name={activeName}
                        text={mainButtonText}
                        selected={selected}
                        hasArrow={configuration.size > 1}
                        noMenu={configuration.size <= 1}
                    />
                </div>
                {configuration.size > 1 && this.renderMenu()}
            </div>
        )
    }
}
